/* TODO: t() */
import createViewComponent from '../../support/rn-web/createViewComponent';

const BlockLabel = createViewComponent({
  tagName: 'label',
  additionalProps: {
    htmlFor: true,
  },
});

export default BlockLabel;
